export default {
  googleAuthorizeTerms: "このアプリは2023年3月10日以降、サポートされなくなります。新しいバージョンの{googleAppName}をインストールしてください。"
};

// @key: @#@"googleAuthorizeTerms"@#@ @source: @#@"This app will not be supported after Mar 10th, 2023. Please install our new version of {googleAppName}."@#@
